<template>
  <!-- 内容详情弹窗 -->
  <BasePopup
    :visible="visible"
    popup-class="content-detail-popup"
    @close="handleClose"
  >
    <div class="content-detail" v-if="contentDetail">
      <div
        v-if="
          contentDetail.DISPLAY_PIC_LIST &&
          contentDetail.DISPLAY_PIC_LIST.length > 0
        "
        class="content-images"
      >
        <!-- 使用 Swiper 轮播图 -->
        <swiper
          :modules="modules"
          :slides-per-view="1"
          :space-between="0"
          :navigation="contentDetail.DISPLAY_PIC_LIST.length > 1"
          :loop="contentDetail.DISPLAY_PIC_LIST.length > 1"
          class="image-swiper"
        >
          <swiper-slide
            v-for="(pic, index) in contentDetail.DISPLAY_PIC_LIST"
            :key="index"
            class="image-slide"
          >
            <img
              :src="pic"
              :alt="`图片 ${index + 1}`"
              class="content-image"
              @click="handlePreviewImage(pic)"
              @error="handleImageError"
            />
          </swiper-slide>
        </swiper>
      </div>

      <div class="content-info">
        <div class="content-author">
          <div
            class="author-avatar"
            :class="`avatar-${contentDetail.DISPLAY_AVATAR_ID || 1}`"
          ></div>
          <div class="author-name">
            {{ contentDetail.DISPLAY_LOGIN_ACCOUNT }}
          </div>
        </div>
        <div class="content-header">
          <div class="content-title">{{ contentDetail.TITLE }}</div>
          <div 
            v-if="showDeleteButton" 
            class="delete-button" 
            @click="handleDeleteCreation"
            title="删除作品"
          >
            <i class="delete-icon"></i>
          </div>
        </div>
        <div class="content-time">{{ contentDetail.DISPLAY_TIME }}</div>
        <div class="content-body">
          <div class="content-text">{{ contentDetail.CONTENT }}</div>
        </div>
        <div class="content-actions">
          <div class="like-action" @click="handleToggleLike(contentDetail.ID)">
            <i class="like-icon" :class="{ liked: +contentDetail.IS_LIKE }"></i>
            <span class="like-count">{{
              contentDetail.DISPLAY_LIKE_COUNT || contentDetail.LIKE_COUNT || 0
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </BasePopup>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
import BasePopup from "./BasePopup.vue";

// 导入 Swiper 样式
import 'swiper/css';
import 'swiper/css/navigation';

// Swiper 模块
const modules = [Navigation];

// 定义props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  contentDetail: {
    type: Object,
    default: null,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
  showDeleteButton: {
    type: Boolean,
    default: false,
  },
});

// 定义emits
const emit = defineEmits(["close", "toggleLike", "previewImage", "deleteCreation"]);

// 关闭弹窗
const handleClose = () => {
  emit("close");
};

// 切换点赞
const handleToggleLike = (id) => {
  emit("toggleLike", id);
};

// 预览图片
const handlePreviewImage = (imageUrl) => {
  emit("previewImage", imageUrl);
};

// 删除作品
const handleDeleteCreation = () => {
  window.activityDataLayer.push({
    eventName: "show_popup",
    eventType: "删除弹窗",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  emit("deleteCreation", props.contentDetail);
};

// 图片加载错误处理
const handleImageError = (event) => {
  event.target.src = import.meta.env.BASE_URL + 'default-pic.png';
};
</script>

<style scoped>
/* 确保 Swiper 组件在弹窗中正确显示 */
.content-images {
  position: relative;
}

.image-swiper {
  /* 确保 Swiper 容器正确设置 */
  --swiper-theme-color: #ffffff;
  --swiper-navigation-size: 20px;
}

/* 当只有一张图片时隐藏导航和分页 */
.image-swiper:has(.swiper-slide:only-child) .swiper-button-prev,
.image-swiper:has(.swiper-slide:only-child) .swiper-button-next,
.image-swiper:has(.swiper-slide:only-child) .swiper-pagination {
  display: none !important;
}

/* 图片加载状态 */
.content-image {
  transition: opacity 0.3s ease;
  cursor: pointer;
}

.content-image:hover {
  opacity: 0.9;
}

.content-image:not([src]),
.content-image[src=""] {
  opacity: 0;
}

/* 默认图片样式 */
.default-image .content-image {
  opacity: 0.7;
}
</style>
